// Option-set constants mirroring the core option sets (source of truth).
// Values must stay byte-identical to the stored option values — do not rename or localize.

/** Option set: shift_type */
export const SHIFT_TYPES: string[] = ['Regular', 'Night', 'Holiday']

/** Option set: shift_approval_status ('Deleted' deliberately omitted — the delete flow covers it) */
export const SHIFT_APPROVAL_STATUSES: string[] = [
  'Draft',
  'Approved',
  'Attended (no changes)',
  'Attended (with changes)',
  'Declined',
]

/** Option set: order_status (order payment status) */
export const ORDER_PAYMENT_STATUSES: string[] = [
  'Partial',
  'Paid',
  'Proceed to Card Payment',
  'Pay via Invoice',
  'Proceed to Additional Card',
  'Cancelled',
]

/** Option set: pay_option */
export const PAY_OPTIONS: string[] = ['Card', 'Invoice', 'Cash']

/** Option set: delivery types */
export const DELIVERY_TYPES: string[] = ['Self pick up', 'Courier delivery', 'Merchant delivery']

/** Option set: taxes (VAT rates; only the rate(s) the backoffice offers today) */
export const VAT_RATES: string[] = ['24%']
